module.exports = __webpack_public_path__ + "img/plusIcon.b19d83f6.svg";